import {
	KActionDialog,
	KDataTable,
	KDataTableMenu,
	KDateTimeRange
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { deleteDriverTimeOff } from "@/utils/http-calls";

export default KDataTable.extend( {
	name: "KDriverTimeOffTable",

	props: {
		idDriver: Number,

		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There is no time off to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching time off found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "startDate"
		},

		sortDesc: {
			...KDataTable.options.props.sortDesc,
			default: true
		}
	},

	computed: {
		defaultHeaders() {
			return [
				!this.idDriver && {
					text: "Driver",
					value: "driver.user.name"
				},
				{
					text: "Time Off",
					value: "startDate"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteDriverTimeOff( idDriver, idTimeOff ) {
			return deleteDriverTimeOff( idDriver, idTimeOff )
			.then( () => {
				this.removeTimeOffData( idTimeOff );

				this.$store.commit( "toasts/SHOW", {
					color: "success",
					text: "Time off deleted"
				} );
			} );
		},

		removeTimeOffData( idTimeOff ) {
			const deleteIndex = this.items.findIndex( timeOff => idTimeOff === timeOff.id );

			if ( deleteIndex !== -1 ) {
				this.$delete( this.items, deleteIndex );
			}
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.startDate": ( { item } ) =>
					<KDateTimeRange
						allDay={Boolean( item.allDay )}
						endDate={item.endDate}
						endTime={item.endTime}
						startDate={item.startDate}
						startTime={item.startTime}
					></KDateTimeRange>,

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "yardDriverTimeOff",
								params: {
									idDriver: this.idDriver ? this.idDriver : item.driver.id,
									idTimeOff: item.id
								}
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "deleteDriverTimeOff" )}
								onConfirm={() => this.deleteDriverTimeOff( item.idDriver, item.id )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Time Off"
							>
								Are you sure you want to delete this time off?
							</KActionDialog>
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
